import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { mediaQuery } from '@/ui/utils';

const variant = {
  mobile: mediaQuery.only('mobile'),
  mobileLandscape: mediaQuery.only('mobileLandscape'),
  tablet: mediaQuery.only('tablet'),
  desktop: mediaQuery.only('desktop'),
  desktopLarge: mediaQuery.only('desktopLarge'),
  wideScreen: mediaQuery.only('widescreen'),
  fhd: mediaQuery.from('fhd'),
};

export const ExternalLink = styled.a`
  color: ${(p) => p.theme.colors.primary.main};
`;

export const DividerStyled = styled.div`
  height: 1px;
  background: ${({ theme }) => theme.colors.neutral.outline1};
`;

export const Background = styled.div`
  background: ${(p) => p.theme.tones.neutral[99]};
`;

export const FooterWrapper = styled.footer`
  color: ${(p) => p.theme.colors.neutral.onContainer};
  ${(p) => p.theme.typography.body2}
`;

export const FooterLayout = {
  Top: styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 32px;
    padding-top: 76px;

    ${variant.mobile} {
      padding-bottom: 7px;
    }
    ${variant.mobileLandscape} {
      padding-bottom: 7px;
    }

    ${variant.tablet} {
      padding-bottom: 7px;
    }

    ${variant.desktop} {
      padding-bottom: 53px;
      justify-content: flex-start;
    }

    ${variant.desktopLarge} {
      padding-bottom: 53px;
      justify-content: flex-start;
    }

    ${variant.wideScreen} {
      padding-bottom: 53px;
      justify-content: flex-start;
    }

    ${variant.fhd} {
      padding-left: 0;
      padding-right: 0;
      padding-bottom: 53px;
      justify-content: flex-start;
    }
  `,
  Bottom: styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    ${variant.mobile} {
      padding-top: 16px;
      padding-bottom: 24px;
    }

    ${variant.mobileLandscape} {
      padding-top: 16px;
      padding-bottom: 24px;
    }

    ${variant.tablet} {
      padding-top: 16px;
      padding-bottom: 24px;
    }

    ${variant.desktop} {
      padding-top: 32px;
      padding-bottom: 64px;
      flex-direction: row;
      justify-content: space-between;
    }

    ${variant.desktopLarge} {
      padding-top: 32px;
      padding-bottom: 64px;
      flex-direction: row;
      justify-content: space-between;
    }

    ${variant.wideScreen} {
      padding-top: 32px;
      padding-bottom: 64px;
      flex-direction: row;
      justify-content: space-between;
    }

    ${variant.fhd} {
      padding-top: 32px;
      padding-bottom: 64px;
      padding-left: 0;
      padding-right: 0;
      flex-direction: row;
      justify-content: space-between;
    }
  `,
};

export const TopNavigationGroupStyled = styled.div`
  display: flex;
  flex-direction: row;
  gap: 32px;
`;

export const LogoLink = styled(Link)`
  display: none;
  ${variant.desktop} {
    display: block;
  }
  ${variant.desktopLarge} {
    display: block;
  }
  ${variant.wideScreen} {
    display: block;
  }
  ${variant.fhd} {
    display: block;
  }
`;

export const CollegialLogo = styled.img`
  display: block;
  width: 70px;
  height: 70px;
`;

export const Support = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  ${variant.mobile} {
    align-self: flex-start;
  }

  ${variant.mobileLandscape} {
    flex-direction: row;
    gap: 8px;
  }

  ${variant.tablet} {
    flex-direction: row;
    gap: 8px;
  }

  ${variant.desktop} {
    flex-direction: row;
    gap: 8px;
    align-self: flex-end;
    margin-left: auto;
  }

  ${variant.desktopLarge} {
    flex-direction: row;
    gap: 8px;
    align-self: flex-end;
    margin-left: auto;
  }

  ${variant.wideScreen} {
    flex-direction: row;
    gap: 8px;
    align-self: flex-end;
    margin-left: auto;
  }

  ${variant.fhd} {
    flex-direction: row;
    gap: 8px;
    align-self: flex-end;
    margin-left: auto;
  }
`;

export const LinksTop = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
`;

export const Copyright = styled.div`
  ${({ theme }) => theme.typography.body2};

  ${variant.mobile} {
    width: 100%;
    order: 2;
  }

  ${variant.mobileLandscape} {
    width: 100%;
    order: 2;
  }

  ${variant.tablet} {
    width: 100%;
    order: 2;
  }
`;

export const LinksBottom = styled.div`
  display: flex;
  padding: 0 16px;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;

  ${variant.mobile} {
    width: 100%;
    order: 1;
    align-items: flex-end;
  }

  ${variant.mobileLandscape} {
    width: 100%;
    order: 1;
    align-items: flex-end;
  }

  ${variant.tablet} {
    width: 100%;
    order: 1;
    align-items: flex-end;
  }

  ${variant.desktop} {
    flex-direction: row;
    gap: 32px;
    padding: 0;
  }

  ${variant.desktopLarge} {
    flex-direction: row;
    gap: 32px;
    padding: 0;
  }

  ${variant.wideScreen} {
    flex-direction: row;
    gap: 32px;
    padding: 0;
  }

  ${variant.fhd} {
    flex-direction: row;
    gap: 32px;
    padding: 0;
  }
`;

export const TextLink = styled(Link)`
  color: ${(p) => p.theme.colors.primary.main};
`;

export const AppVersion = styled.span`
  display: none;
`;
